import { TaskCompletion } from 'graphql-common';
import { SelectOption } from '@lib/components/Select/types';
import { getFormattedDate } from '@lib/utils/dateTimeHelpers';
import { dateTimeFormatEU } from '@lib/enums/dateTime';

// Shared by every "Create intervention" entry point that prefills the
// Completions field (single-row and bulk) — see InterventionCreatePrefillState.
export default function getTaskCompletionSelectOption(
  completion: TaskCompletion,
): SelectOption {
  return {
    value: completion.id,
    label: completion.createdAt
      ? getFormattedDate(completion.createdAt, dateTimeFormatEU)
      : completion.id,
  };
}
